// VM setup that both the page and the dodge worker do, so the worker's copy of the VM sees the
// same field and inputs as the one on screen.

/** Actors this far outside the field are culled. */
const MARGIN = 32;

/** The calls setup makes. Both wasm builds have them. */
export interface SetupVm {
  setBounds(minX: number, minY: number, maxX: number, maxY: number): void;
  setInput(name: string, value: number): void;
  clearInput(name: string): void;
  setBeat(bpm: number, offsetTicks: number): void;
  clearBeat(): void;
}

/** A fresh VM's field: the cull bounds and the field-w and field-h inputs. */
export function prepare(vm: SetupVm, w: number, h: number): void {
  setField(vm, w, h);
  vm.setInput('field-h', h);
}

/** The field width sets the cull bounds and, by testbed convention, the field-w input. */
export function setField(vm: SetupVm, w: number, h: number): void {
  vm.setBounds(-MARGIN, -MARGIN, w + MARGIN, h + MARGIN);
  vm.setInput('field-w', w);
}

export function setBeat(vm: SetupVm, beat: [number, number] | null): void {
  if (beat === null) vm.clearBeat();
  else vm.setBeat(beat[0], beat[1]);
}

export function setVar(vm: SetupVm, name: string, value: number | null): void {
  if (value === null) vm.clearInput(name);
  else vm.setInput(name, value);
}
